import { z } from 'zod'

export const SortTimestampSchema = z.union([z.string(), z.number(), z.boolean()]).describe('The timestamp to sort by')

export type SortTimestamp = z.infer<typeof SortTimestampSchema>

export const SortCursorSchema = z
  .union([SortTimestampSchema, SortTimestampSchema.array()])
  .describe(
    'Sort cursor for pagination: the sort values of the last row on the previous page, usually an array ending with an id tiebreaker. Send it back unchanged. A single value is accepted from older clients, but rows that share it can be skipped or repeated at the page boundary.'
  )

export type SortCursor = z.infer<typeof SortCursorSchema>

export const PaginatedCursorInputSchema = z.object({
  sortTimestamp: SortCursorSchema.optional().meta({
    description: 'Sort cursor from the previous page. Send it back unchanged.',
  }),
})
export type PaginatedCursorInput = z.infer<typeof PaginatedCursorInputSchema>

export const PaginatedInputSchema = z.object({
  ...PaginatedCursorInputSchema.shape,
  size: z.number().int().positive().max(10_000).optional(),
})
export type PaginatedInput = z.infer<typeof PaginatedInputSchema>

export const PaginatedOutputSchema = z.object({
  sortTimestamp: SortCursorSchema.optional().meta({
    description: 'Sort cursor to fetch the next page. Send it back unchanged.',
  }),
  total: z.number().int().nonnegative().optional().meta({ description: 'Total number of matching records.' }),
})
export type PaginatedOutput = z.infer<typeof PaginatedOutputSchema>
